import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

function BarChartCom({ data, customWidth, volumeUnit }) {
  return (
    <BarChart
      dataset={data}
      xAxis={[
        {
          scaleType: "band",
          dataKey: "vehicleModel", // X-axis: vehicleModel
          categoryGapRatio: 0.7,
          barGapRatio: 1,
          axisLabelProps: {
            style: {
              fill: "#F38712", // Customize text color
              fontSize: "14px", // Adjust font size
              fontWeight: "bold",
            },
          },
        },
      ]}
      yAxis={[
        {
          valueFormatter: (value) => `${value}`, // Display raw values
          disableLine: "true",
          disableTicks: "true",
        },
      ]}
      series={[
        {
          dataKey: "fuelQuantity", // Bar 1: fuelQuantity
          valueFormatter: (value) => `${value}` + `${volumeUnit}`,
          color: "#D7DBEC", // Bar color for fuel quantity
        },
        {
          dataKey: "fuelCost", // Bar 2: fuelCost
          valueFormatter: (value) => `$${value}`,
          color: "#F38712", // Bar color for fuel cost
        },
      ]}
      margin={{ left: 80, top: 30, bottom: 40, right: 10 }}
      width={customWidth}
      grid={{ horizontal: true }}
    />
  );
}

export default BarChartCom;
